<template>
  <v-text-field v-bind="$attrs"
    v-model="text"
    single-line
    dense
    outlined
    @update:error="$emit('update:error', $event)"
    @keydown="keydown"
  >
  <template v-slot:append>
    <div v-if="showValid">
        <v-progress-circular
          v-if="loading"
          :size="iconSize"
          color="info"
          indeterminate
        ></v-progress-circular>
        <v-icon
          v-else-if="valid"
          color="green"
          :size="iconSize"
        >mdi-check</v-icon>
        <v-icon
          v-else
          color="red"
          :size="iconSize"
        >mdi-alert-circle</v-icon>
      </div>
    </template>
  </v-text-field>
</template>
<script>
export default {
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: "",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    valid: {
      type: Boolean,
      default: false,
    },
    showValid: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      text: this.value,
    };
  },
  computed: {
    iconSize() {
      return "24";
    },
  },
  methods: {
    keydown(e) {
      this.$emit('keydown', e)
    }
  },
  watch: {
    text: {
      immediate: true,
      handler(val) {
        this.$emit("input", val);
      },
    },
  },
}
</script>
<style  lang="scss" scoped>
::v-deep  fieldset {
  border: 2px solid;
  border-radius: 16px;
}
</style>